import { BulkActionsApplicableAction } from "components/BulkActions/ChooseActionStep/types";
import {
  BulkActionItemID,
  BulkActionsActionsPerItem,
  BulkActionsStep,
  BulkActionsVariant,
} from "components/BulkActions/types";
import { Worker } from "types/generated";
import BulkActionsDrawerActionStepsItems from "components/BulkActions/Drawer/ActionSteps/Items";
import BulkActionsDrawerActionStepsFooter from "components/BulkActions/Drawer/ActionSteps/Footer";
import BulkActionsPatternsActionsList from "components/BulkActionsPatterns/ActionsList";

import { BulkPrivateWorkerPoolWorkersActions } from "./types";
import PrivateWorkerPoolWorkersBulkActionsSelectedItem from "./SelectedItem";

type PrivateWorkerPoolWorkersBulkActionsSelectedItemsViewProps = {
  items: Worker[];
  onItemDismiss: (id: BulkActionItemID) => void;
  availableActions: Array<BulkActionsApplicableAction<BulkPrivateWorkerPoolWorkersActions>>;
  actionsPerItem: BulkActionsActionsPerItem<BulkPrivateWorkerPoolWorkersActions>;
  onEmptyActionsCancel: () => void;
};

const PrivateWorkerPoolWorkersBulkActionsSelectedItemsView = ({
  items,
  onItemDismiss,
  actionsPerItem,
  availableActions,
  onEmptyActionsCancel,
}: PrivateWorkerPoolWorkersBulkActionsSelectedItemsViewProps) => {
  return (
    <>
      <BulkActionsDrawerActionStepsItems selectedItemsCount={items.length}>
        {items.map((item) => (
          <PrivateWorkerPoolWorkersBulkActionsSelectedItem
            key={item.id}
            item={item}
            onDismiss={onItemDismiss}
            itemActions={actionsPerItem.get(item.id)}
            allActionsQty={availableActions.length}
            step={BulkActionsStep.ChooseAction}
          />
        ))}
      </BulkActionsDrawerActionStepsItems>

      <BulkActionsDrawerActionStepsFooter>
        <BulkActionsPatternsActionsList
          variant={BulkActionsVariant.Drawer}
          availableActions={availableActions}
          onEmptyActionsCancel={onEmptyActionsCancel}
        />
      </BulkActionsDrawerActionStepsFooter>
    </>
  );
};

export default PrivateWorkerPoolWorkersBulkActionsSelectedItemsView;
